import React from "react";
import { deleteDocument } from "../../../../../apis/deleteDocument";
import "./DeleteDocuments.scss";
import { toast } from "react-toastify";
import { hideDocument } from "../../../../../apis/HideDocument";

export interface TextProps {
  handleCloseUnHideModal: any;
  docID: any;
  setIsHideLoading: any;
}

const UnHideDocument: React.FC<TextProps> = ({
  handleCloseUnHideModal,
  docID,
  setIsHideLoading
}) => {
  const onHideDocument = () => {
    setIsHideLoading(true)
    const update = {
      id: docID,
      is_hidden: false,
    };
    hideDocument(update)
      .then((resp) => {
        setIsHideLoading(false)
        handleCloseUnHideModal();
        toast.success("Document Unhide Successfully");
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error hiding documents. Please try again.");
        handleCloseUnHideModal();
      });
  };
  return (
    <div className="delete-document-container">
      <h3>Are you sure to Unhide this Document.?</h3>
      <div className="delete-buttons">
        <button onClick={onHideDocument}>Yes</button>
        <button onClick={handleCloseUnHideModal}>Cancel</button>
      </div>
    </div>
  );
};

export default UnHideDocument;
